export default {
  message: {
    hello: "你好",
    welcome: "歡迎使用我們的應用",
    cn: "簡體中文",
    fcn: "繁體中文",
    en: "English",
    home: "首頁",
    employeeList: "員工列表",
    restaurantList: "餐廳列表",
    lloginName: "登錄名",
    password: "密碼",
    loginin: "登錄",
    inplloginName: "請輸入郵箱",
    inpPassword: "請輸入密碼",
    RestaurantName: "餐廳名稱",
    Contactinformation: "聯繫方式",
    region: "地區",
    address: "地址",
    workersEmployed: "用工人數",
    Blacklist: "黑名單",
    Employmenttime: "打卡時間",
    QRcode: "二維碼",
    group: "集團",
    Businesshours: "營業時間",
    Businessstatus: "營業狀態",
    Travelmethod: "行程方式",
    operation: "操作",
    edit: "編輯",
    delete: "刪除",
    Add: "新增",
    taurantname: "請輸入餐廳名",
    Pleaseselectaregion: "請選擇地區",
    Successfullyadded: "添加成功",
    Successfullydeleted: "刪除成功",
    Deletefailed: "刪除失敗",
    deletethecurrententry: "刪除當前項",
    confirm: "確定",
    prompt: "提示",
    Permanentlydelete: "此操作將永久刪除該數據 是否繼續?",
    Successfullymodified: "修改成功",
    changeStatus: "此操作將切換員工不確定狀態 是否繼續",
    canceled: "已取消",
    changeFailed: "切換狀態失敗",
    changeSuccess: "切換狀態成功",
    Export: "導出",
    Name: "姓名",
    Gender: "性別",
    Phone: "手機號",
    Paymentmethod: "收款方式",
    Selfie: "自拍",
    IDcard: "身份證",
    Unqualifiedemployees: "不合員工",
    Remarks: "備註",
    Employeeidentity: "員工身份",
    Mattersattention: "注意事項",
    Fixedposition: "固定位置",
    LastWork: "最後工作餐廳位置",
    LongtermWorker: "長工",
    ShorttermWorker: "短工",
    TemporaryWorkers: "臨時工",
    SubstituteWorker: "替工",
    Transfer: "轉賬",
    cash: "現金",
    check: "支票",
    userList: "用戶列表",
    userName: "用戶名",
    avatar: "頭像",
    account: "賬號",
    role: "角色",
    creatTime: "創建時間",
    lastLoginTime: "最後登錄時間",
    mailbox: "郵箱",
    lastLoginIp: "最後登錄ip",
    accountStatus: "賬號狀態",
    roleList: "角色列表",
    menuList: "菜單列表",
    pleaseEnter: "請輸入",
    jiazaishi: "加載失敗",
    EmployeeInformation: "員工管理",
    RestaurantInformation: "餐廳管理",
    usermanagement: "用戶管理",
    name: "名稱",
    description: "簡介",
    index: "序號",
    rolename: "角色名",
    kejian: "可見",
    bukejian: "不可見",
    noclick: "取消",
    seatchmap: "搜索goole地圖",
    dakaf: "打卡範圍",
    loginout: "退出登錄",
    PersonalCenter: "個人中心",
    groupList: "集團列表",
    chineseName: "中文名",
    englishName: "英文名",
    contacts: "聯繫人",
    contactNumber: "聯繫電話",
    settlementMethod: "結算方式",
    spaymentStatus: "本月收款情況",
    receivingAddress: "收款地址",
    starttime: "開始時間",
    endtime: "結束時間",
    groupAddress: "集團地址",
    invoice: "發票",
    correctFormat: "正確格式的",
    print: "打印",
    employeeStatus: "狀態",
    auditStatus: "審覈狀態",
    setchuser: "搜索用戶",
    managerNumber: "經理手機號",
    enable: "啓用",
    disabled: "禁用",
    setground: "搜索集團",
    addclock: "添加打卡時間",
    clockname: "打卡名稱",
    placeholderclockname: "請輸入內容 列如：早班",
    auditEmployeelist: "審覈列表",
    sex: "性別",
    topjingli: "上級經理",
    auditStatus0: "未審覈",
    auditStatus1: "審覈通過",
    auditStatus2: "審覈不通過",
    refuserReason: "拒絕原因",
    Audit: "審覈",
    contactPerson: "聯繫人",
    updatasuc: "更新成功",
    updatasucphoneid: "此操作將重置手機id",
    coledit: "顏色編輯",
    notices: "消息管理",
    noticesList: "通知列表",
    name_tc: "名稱",
    contact_phone: "聯繫方式",
    business_status: "營業狀態",
    restaurantgroup_id: "集團名稱",
    districts_id: "地區",
    navigation_description: "行程方式",
    address_tc: "地址",
    contact_person: "聯繫人",
    noticeTitle: "通知標題",
    noticeContent: "通知內容",
    noticeType: "通知類型",
    employeeIds: "指定員工",
    employeeType: "員工類型",
    groupName: "分組名稱",
    employeeNum: "指定員工人數",
    backlist1: "黑名單",
    color: "顏色",
    leaveMessage: "留言類型",
    messageRecord: "留言記錄",
    is_emergency: "是否緊急",
    created_at: "創建時間",
    updated_at: "更新時間",
    goodli: "好碗力",
    details: "詳情",
    yes: "是",
    no: "否",
    weigh: "權重",
    name_en: "名稱（英文）",
    type_name_tc: "留言類型",
    msgContent: "留言內容",
    created_start: "留言開始時間",
    created_end: "留言結束時間",
    handle_end: "處理時間",
    msgName: "留言人",
    msgObject: "留言對象",
    schedulingManagement: "排班管理",
    scheduling: "排班信息",
    mark: "餐廳簡稱",
    placeSelect: "請選擇",
    nullData: "暫無數據",
    Monday: "週一",
    employenamee: "員工姓名",
    adddname: "添加",
    placRautse: "請先選擇餐廳",
    placYuangong: "請選擇員工",
    dateType1: "常規排班",
    dateType2: "節假日",
    dateType3: "特殊排班",
    dateType4: "排班類型",
    startDdate: "用工開始時間",
    endDdate: "用工結束時間",
    isRest1: "不休息",
    isRest2: "休息",
    isRest3: "是否休息",
    clockStart1: "打卡開始時間",
    clockEnd1: "打卡結束時間",
    taglds: "班次",
    weeks1: "週一",
    weeks2: "週二",
    weeks3: "週三",
    weeks4: "週四",
    weeks5: "週五",
    weeks6: "週六",
    weeks0: "週日",
    weeks8: "用工週期",
    minusHours: "減少工時",
    weigh1: "優先級",
    weigh3: "數字越大優先級越高",
    addbanci: "請選擇班次",
    addyonggo: "請選擇用工週期",
    workTag: "打卡班次",
    workTagname: "班次名稱",
    descs: "描述",
    isedit1: "是否修改",
    districts: "地區列表",
    districtName: "地區名稱",
    sex1: "男",
    sex2: "女",
    yes1: "正確",
    operationsuc: "操作成功",
    maps_address: "谷歌地址",
    workClockIn: "打卡記錄",
    employee: "員工姓名",
    onwork_at: "上班打卡時間",
    offwork_at: "下班打卡時間",
    status: "狀態",
    dateselection: "日期選擇",
    supervisor: "所屬主管",
    updatePhone: "更新手機",
    refresh: "刷新",
    versionManage: "版本管理",
    read: "已讀",
    start_date: "生效開始日期",
    end_date: "生效結束日期",
    noRead: "未讀",
    photoRec: "拍照記錄",
    tiemchanchan: "時間選擇",
    age: "年齡",
    photo: "照片",
    isOnWork: "是否在職",
    liveDistricts: "居住地區",
    restaurant: "排班餐廳",
    restaurantGroup: "排班集團",
    handle_at: "處理時間",
    content: "留言內容",
    customer: "客服排班",
    weekday: "工作日",
    weeks7: "週日",
    weeks11: "休息週期",
    worktimme3: "用工時間",
    districtsss: "排班地區",
    scheduleTime: "可調度時間",
    date: "日期",
    settlement_method: "收款方式",
    remark: "備註",
    live_districts_id: "居住地區",
    hourly_wage: "時薪",
    service_level: "能力等級",
    work_hardness: "工作難度等級",
    arrange_hardness: "安排難度等級",
    navigation_tc: "行程方式",
    phone: "電話",
    name_tc_short: "餐厅简称",
    synchronous: "同步排班",
    leavesPerson: "离职员工",
    resign_date: "离职日期",
    min_age: "最小年龄",
    max_age: "最大年龄",
    supervisor_phone: "主管手机号",
    identity_image: "身份证照片",
    working_ability: "工作能力",
    workking_attitude: "工作態度",
    cooperation: "合作时间",
    derivedgrain: "导出粮表",
    clientuser: "客户端列表",
    referrer: "推荐人列表",
    assistList: "协助列表",
    operateLog: "操作记录",
    salaryPaymentCheck: "出糧檢查",
    attitude_level: "態度等級",
    questionnaire: "问卷列表",
    workuse:'任务导出',
    merchant:'商户管理',
    contactPhone:'聯繫電話',
    search:'搜尋',
    voiceCustomerServiceRecords: '語音客服記錄',
    voiceCallRecords: '語音記錄',
    voiceComplaintRecords: '投訴記錄'
    ,recruitmentApplications: '招聘資料查詢'
    ,leaveApplications: '請假記錄'
  }
};



// WEBPACK FOOTER //
// ./src/locales/fcn.js